<template>
  <div id="app">
    <sui-container>
      <div id="logo" @click="goHome" />
      <div id="banner" />

      <Home />

      <Footer />
    </sui-container>
  </div>
</template>
<script>
  import Home from './views/Home.vue'
  import Footer from './components/Footer.vue'

  export default {
    name: 'app',
    components: {
      Home,
      Footer
    },
    methods: {
      goHome() {
        this.$router.push('/')
      },
    }
  }
</script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  body, html, .pusher {
    background-color: #0087cb;
    background: url(assets/img/background-clouds.jpg) no-repeat center center fixed !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
  }

  #logo {
    background-image: url(assets/img/logo-shell-white.png);
    background-repeat: no-repeat;
    background-size: 80px 56px;
    height: 71px;
    left: 5px;
    margin: 0 auto;
    position: relative;
    top: 5px;
    width: 858px;
    cursor: pointer;
  }

  #banner {
    background-image: url(assets/img/banner_online.png);
    width: 477px;
    height: 156px;
    background-repeat: no-repeat;
    margin: 0 auto;
    position: relative;
    top: 0px;
  }
</style>
